import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { mergeStyles } from 'wix-rich-content-common';
import classNames from 'classnames';

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".kdHal{align-items:flex-start;display:flex;flex-direction:column;width:174px}[dir] .kdHal{padding:10px 0}.kdHal *{color:var(--ricos-settings-text-color,#333);font-size:14px;height:42px;width:100%}[dir] .kdHal *{background-color:transparent;border:none}[dir=ltr] .kdHal *{padding:0 0 0 26px;text-align:left}[dir=rtl] .kdHal *{padding:0 26px 0 0;text-align:right}.kdHal :hover{color:var(--ricos-settings-action-color,var(--ricos-action-color-fallback,#0261ff))}[dir] .kdHal :hover{cursor:pointer}.FN-eb,._6XOGg{color:var(--ricos-settings-action-color,var(--ricos-action-color-fallback,#0261ff))}.BIwjE{display:flex;flex-direction:column}[dir] .BIwjE{padding:16px 18px}[dir] .BIwjE>*{margin:11px 0}.BIwjE *{font-size:14px}[dir] .BIwjE *{background-color:transparent;border:none}.-KMdh{display:flex}.-KMdh *{flex:1;height:40px}[dir] .-KMdh *{padding:0;text-align:center}.ulBH7{display:flex;justify-content:space-between}[dir] .ulBH7 *{padding:0}.ulBH7 :nth-child(2){color:var(--ricos-settings-action-color,var(--ricos-action-color-fallback,#0261ff))}.vNYLZ{display:flex;flex-direction:column;width:248px}[dir] .vNYLZ{padding:10px 0}[dir] .vNYLZ>*{margin:9px 20px}.vNYLZ *{color:var(--ricos-settings-text-color,#333);font-size:14px}.J2FTh{width:unset}[dir] .J2FTh{border-radius:unset}.q-EzR{display:flex;height:40px;justify-content:space-between;line-height:40px}.q-EzR *{font-size:14px}.q-EzR input{color:var(--ricos-settings-text-color,#333);width:42px}[dir] .q-EzR input{border:1px solid var(--ricos-settings-inputs-border-color,rgba(51,51,51,.2));border-radius:var(--ricos-settings-inputs-border-radius,0)}[dir=ltr] .q-EzR input{padding-left:12px}[dir=rtl] .q-EzR input{padding-right:12px}.q-EzR input::placeholder{color:var(--ricos-settings-inputs-placeholder-color,rgba(0,0,0,.4))}[dir] .q-EzR input:focus{border:1px solid var(--ricos-settings-inputs-border-color,rgba(51,51,51,.2))}.q-EzR input::-webkit-inner-spin-button,.q-EzR input::-webkit-outer-spin-button{-webkit-appearance:none}[dir] .q-EzR input::-webkit-inner-spin-button,[dir] .q-EzR input::-webkit-outer-spin-button{margin:0}.qh3J8{height:1px}[dir] .qh3J8{background-color:var(--ricos-settings-dividers-color,rgba(51,51,51,.2))}.pT4ig{display:flex;height:34px;justify-content:space-between}[dir] .pT4ig *{background-color:transparent;border:none;cursor:pointer;padding:0}.pT4ig :nth-child(2){color:var(--ricos-settings-action-color,var(--ricos-action-color-fallback,#0261ff))}[dir] .yZGbV{border:1px solid #ededed;border-radius:6px;box-shadow:var(--ricos-settings-whitebox-box-shadow,0 4px 8px 0 rgba(0,0,0,.1),0 0 4px 0 rgba(0,0,0,.1))}[dir] ._2SkBB{border:1px solid #ededed;border-radius:unset;box-shadow:0 -4px 8px 0 rgba(0,0,0,.05)}.vy1Gk{bottom:auto;position:fixed}[dir] .vy1Gk{background:#fff;padding:0}[dir=ltr] .vy1Gk{right:auto}[dir=rtl] .vy1Gk{left:auto}[dir] .BmDjy{border-radius:unset;box-shadow:unset}.sjSg9{bottom:0;position:fixed;top:0;z-index:40}[dir] .sjSg9{background-color:transparent}[dir=ltr] .sjSg9{left:0;right:0}[dir=rtl] .sjSg9{left:0;right:0}.ws-wo{position:relative}[dir=ltr] .ws-wo{margin-right:10px}[dir=rtl] .ws-wo{margin-left:10px}.ws-wo .KrS5v{position:absolute;top:50px}[dir] .ws-wo .KrS5v{background:#fff}[dir=ltr] .ws-wo .KrS5v{left:-146px}[dir=rtl] .ws-wo .KrS5v{right:-146px}[dir] .ws-wo .KrS5v button{background-color:transparent}";
var styles = {"lineHeightsPanel":"kdHal","lineHeightsPanel_selectedLineHeight":"FN-eb","lineSpacingMobilePanel_selectedLineHeight":"_6XOGg","lineSpacingMobilePanel":"BIwjE","lineSpacingMobilePanel_heights":"-KMdh","lineSpacingMobilePanel_buttons":"ulBH7","customSpacingPanel":"vNYLZ","customSpacingPanel_mobile":"J2FTh","customSpacingPanel_labeledInput":"q-EzR","lineSpacing_separator":"qh3J8","customSpacingPanel_buttons":"pT4ig","lineSpacingContainer":"yZGbV","lineSpacingContainer_mobile":"_2SkBB","lineSpacingModal":"vy1Gk","lineSpacingModal_mobile":"BmDjy","lineSpacingModalOverlay":"sjSg9","lineSpacingPopup_button":"ws-wo","lineSpacingPopup":"KrS5v"};
styleInject(css_248z);

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
const LineHeightsPanel = ({ selectedHeight, onSave, showCustomPanel, styles: styles2, t }) => {
  const lineHeightElement = (height, isSelected, onClick) => /* @__PURE__ */ React.createElement(
    "button",
    {
      className: isSelected ? styles2.lineHeightsPanel_selectedLineHeight : "",
      key: height,
      onClick: () => onClick(`${height}`)
    },
    height
  );
  const lineHeights = [1, 1.5, 2, 2.5, 3];
  return /* @__PURE__ */ React.createElement("div", { className: styles2.lineHeightsPanel }, lineHeights.map(
    (height) => lineHeightElement(height, parseFloat(selectedHeight) === height, onSave)
  ), /* @__PURE__ */ React.createElement("button", { onClick: showCustomPanel }, t("LineSpacing_customSpacing")));
};
const MobilePanel = ({ selectedHeight, styles: styles2, t, onChange, onSave, onCancel }) => {
  const lineHeightElement = (height, isSelected, onClick) => /* @__PURE__ */ React.createElement(
    "button",
    {
      className: isSelected ? styles2.lineSpacingMobilePanel_selectedLineHeight : "",
      key: height,
      onClick: () => onClick(`${height}`)
    },
    height
  );
  const lineHeights = [1, 1.5, 2, 2.5, 3];
  return /* @__PURE__ */ React.createElement("div", { className: styles2.lineSpacingMobilePanel }, /* @__PURE__ */ React.createElement("div", null, t("LineSpacing_lineSpacing")), /* @__PURE__ */ React.createElement("div", { className: styles2.lineSpacingMobilePanel_heights }, lineHeights.map((height) => {
    const selected = parseFloat(selectedHeight) === height;
    return lineHeightElement(height, selected, onChange);
  })), /* @__PURE__ */ React.createElement(Separator, null), /* @__PURE__ */ React.createElement("div", { className: styles2.lineSpacingMobilePanel_buttons }, /* @__PURE__ */ React.createElement("button", { onClick: onCancel }, t("LineSpacing_cancel")), /* @__PURE__ */ React.createElement("button", { onClick: () => onSave() }, t("LineSpacing_save"))));
};
const LabeledInput = ({
  label,
  name,
  unit = "",
  defaultValue = 0,
  spacing,
  onChange,
  min,
  max
}) => {
  const value = spacing[name] === void 0 ? defaultValue : parseFloat(spacing[name]);
  return /* @__PURE__ */ React.createElement("label", { className: styles.customSpacingPanel_labeledInput }, /* @__PURE__ */ React.createElement("span", null, label), /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "number",
      min,
      max,
      value,
      onChange: (e) => onChange({ [name]: Number(e.target.value) + unit })
    }
  ));
};
const Separator = () => /* @__PURE__ */ React.createElement("div", { className: styles.lineSpacing_separator });
const CustomPanel = ({ spacing, onChange, onSave, onCancel, styles: styles2, t }) => {
  return /* @__PURE__ */ React.createElement("div", { className: styles2.customSpacingPanel }, /* @__PURE__ */ React.createElement(
    LabeledInput,
    {
      label: t("LineSpacing_lineSpacing"),
      name: "line-height",
      defaultValue: 1.5,
      onChange,
      spacing,
      min: 1,
      max: 100
    }
  ), /* @__PURE__ */ React.createElement(Separator, null), /* @__PURE__ */ React.createElement(
    LabeledInput,
    {
      label: t("LineSpacing_beforeParagraph"),
      name: "padding-top",
      unit: "px",
      onChange,
      spacing,
      min: 0,
      max: 250
    }
  ), /* @__PURE__ */ React.createElement(
    LabeledInput,
    {
      label: t("LineSpacing_afterParagraph"),
      name: "padding-bottom",
      unit: "px",
      onChange,
      spacing,
      min: 0,
      max: 250
    }
  ), /* @__PURE__ */ React.createElement("div", { className: styles2.customSpacingPanel_buttons }, /* @__PURE__ */ React.createElement("button", { onClick: onCancel }, t("LineSpacing_cancel")), /* @__PURE__ */ React.createElement("button", { onClick: () => onSave() }, t("LineSpacing_save"))));
};
class Panel extends Component {
  constructor(props) {
    super(props);
    __publicField(this, "showCustomPanel", () => {
      this.setState({ isCustomPanel: true });
    });
    __publicField(this, "onBlur", (e) => {
      const { target, relatedTarget, currentTarget } = e;
      if (!currentTarget.contains(relatedTarget)) {
        setTimeout(() => target.focus());
      }
    });
    __publicField(this, "onChange", (spacing) => {
      const merged = __spreadValues(__spreadValues({}, this.state.spacing), spacing);
      this.setState({ spacing: merged });
      this.props.onChange(merged);
    });
    __publicField(this, "onSave", (spacing) => {
      this.props.onSave(__spreadValues(__spreadValues({}, this.state.spacing), spacing));
    });
    this.state = { spacing: props.spacing };
    this.styles = mergeStyles({ styles, theme: props.theme });
  }
  render() {
    const { onCancel, t, isMobile } = this.props;
    const { isCustomPanel, spacing } = this.state;
    const { styles: styles2, showCustomPanel, onChange, onSave } = this;
    const selectedHeight = spacing["line-height"];
    const onSaveLineHeight = (height) => onSave({ "line-height": height });
    const onChangeLineHeight = (height) => onChange({ "line-height": height });
    const panel = isMobile ? /* @__PURE__ */ React.createElement(
      MobilePanel,
      __spreadValues({}, {
        styles: styles2,
        selectedHeight,
        t,
        onChange: onChangeLineHeight,
        onSave,
        onCancel
      })
    ) : isCustomPanel ? /* @__PURE__ */ React.createElement(CustomPanel, __spreadValues({}, { spacing, onChange, onSave, onCancel, styles: styles2, t, isMobile })) : /* @__PURE__ */ React.createElement(
      LineHeightsPanel,
      __spreadValues({}, { styles: styles2, selectedHeight, showCustomPanel, t, onSave: onSaveLineHeight })
    );
    return (
      // eslint-disable-next-line jsx-a11y/no-static-element-interactions
      /* @__PURE__ */ React.createElement(
        "div",
        {
          onBlur: this.onBlur,
          className: classNames(styles2.lineSpacingContainer, {
            [styles2.lineSpacingContainer_mobile]: isMobile
          })
        },
        panel
      )
    );
  }
}
Panel.propTypes = {
  isMobile: PropTypes.bool,
  onCancel: PropTypes.func,
  onChange: PropTypes.func,
  onCustomPanel: PropTypes.func,
  onSave: PropTypes.func,
  showCustomPanel: PropTypes.func,
  spacing: PropTypes.shape({
    "line-height": PropTypes.string,
    "padding-top": PropTypes.string,
    "padding-bottom": PropTypes.string
  }),
  t: PropTypes.func.isRequired,
  theme: PropTypes.object.isRequired
};
Panel.defaultProps = { spacing: {} };
CustomPanel.propTypes = {
  isMobile: PropTypes.bool,
  onCancel: PropTypes.func,
  onChange: PropTypes.func,
  onSave: PropTypes.func,
  spacing: PropTypes.object,
  styles: PropTypes.object,
  t: PropTypes.func
};
LabeledInput.propTypes = {
  defaultValue: PropTypes.number,
  label: PropTypes.string,
  max: PropTypes.number,
  min: PropTypes.number,
  name: PropTypes.string,
  onChange: PropTypes.func,
  spacing: PropTypes.object,
  unit: PropTypes.string
};
LineHeightsPanel.propTypes = {
  onSave: PropTypes.func,
  selectedHeight: PropTypes.any,
  showCustomPanel: PropTypes.func,
  styles: PropTypes.object,
  t: PropTypes.func.isRequired
};
MobilePanel.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  selectedHeight: PropTypes.string.isRequired,
  styles: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired
};

export { Panel as P, styles as s };
//# sourceMappingURL=LineSpacingPanel-05abb2c4.js.map
